import { omitBy } from 'lodash';

import adjustUrlParams from './adjustUrlParams';
import isEmptyString from './utils/isEmptyString';

const sanitize = (params, onlyTruthyParams) =>
  onlyTruthyParams ? omitBy(params, isEmptyString) : params;

const addParamsToUrl = (url, params = {}, onlyTruthyParams = false) =>
  adjustUrlParams(
    currentParams => ({
      ...currentParams,
      ...sanitize(params, onlyTruthyParams),
    }),
    url
  );

export default addParamsToUrl;
